import { render } from "./SwitchField.vue?vue&type=template&id=28519d81"
import script from "./SwitchField.vue?vue&type=script&lang=js"
export * from "./SwitchField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__